import { Model } from "@/models";
import AutomaticReportCompetitor from "./AutomaticReportCompetitor";
import ReportTemplate from "../Templates/ReportTemplate";

type AutomaticReportUser = {
  id: number;
  email: string;
};

type AutomaticReportProfile = {
  id: number;
  name: string;
  slug: string;
};

export default class AutomaticReport extends Model {
  static type = "automaticReports";

  name?: string;
  kind?: string;
  active?: boolean;
  granularityKind?: string;
  granularityQuantity?: number | null;
  granularityRange?: number[] | null;
  weekType?: string | null;
  lastGeneratedDate?: string | null;

  user!: AutomaticReportUser;
  profile!: AutomaticReportProfile;
  reportTemplate!: ReportTemplate;
  competitor?: AutomaticReportCompetitor;

  createdAt!: Date;
  updatedAt!: Date;
}
